import { maxLength, required } from "@libs/validation/fieldValidators.ts";
import { messageWithData } from "@libs/validation/messageWithData.ts";
import { ValidationMessages } from "@libs/validation/validation.constants.ts";
import { FieldValidator } from "@libs/validation/validation.types.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { PracticeDetailsValues } from "./PracticeDetailsForm.types.tsx";

// Removes the underscores that form part of value in a masked textbox
/* eslint no-template-curly-in-string: "off" */
const requiredNumLengthOnMaskedField =
  (length: number): FieldValidator =>
  value =>
    value &&
    value.replace(/_/gi, "") &&
    parseFloat(value).toString().length !== length
      ? messageWithData(ValidationMessages.requiredNumLength, length.toString())
      : undefined;

const isValidHpiOrgId = (val: string) => {
  if (!val) return;

  // Case for Bp dev - ACC test account. Case Sensitive
  if (new RegExp(/^ZZZ150$/).test(val)) return;

  if (val.length > 1 && !new RegExp("^[G][0-9]").test(val)) {
    return "Must start with G + number";
  } else if (new RegExp("[-]").test(val)) {
    return "Must not contain hyphens";
  } else if (new RegExp("[oiOI]").test(val)) {
    return "Must not contain the letters o,O,i,I";
  }
  return;
};

export class PracticeDetailsValidator extends Validator<PracticeDetailsValues> {
  constructor() {
    super();
    this.forField("businessName", [required(), maxLength(100)]);
    this.forField("hpiOrganisationId", [maxLength(8), isValidHpiOrgId]);
    this.forField("abn", [requiredNumLengthOnMaskedField(11)]);
    this.forField("nzbn", [requiredNumLengthOnMaskedField(13)]);
    this.forField("tagLine", maxLength(150));
    this.forField("hpiOrganisationName", maxLength(40));
  }
}
